const swea = require('swea');
import * as globals from '../globals';
const ContextMenuStateServiceActions = swea.react.actions.ContextMenuStateServiceActions;
const InstructionServiceActions = swea.react.actions.InstructionServiceActions;
const BrowserInfo = swea.react.helpers.BrowserInfo;

class CustomMeasureInteraction extends swea.editor.interactions.MeasureInteraction {
  /**
   * The constructor.
   * @param { object } options An option object, see {@link MeasureInteraction} for more info.
   */
  constructor(options) {
    super(options);
    this._disabledInteractionClasses = [];
  }

  /**
   * Initializes the interaction.
   * @param element the element that the interaction listens to.
   * @param viewerId the viewer id of the viewer the interaction operates in.
   */
  initialize(element, viewerId){
    super.initialize(element, viewerId);

    // Close tool with Escape
    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.ESC],
      this,
      () => {
        this.terminate();
        ContextMenuStateServiceActions.closeContextMenu(
          globals.LOWER_CONTEXT_MENU
        );
      }
    ));

    // Remove last point with Backspace
    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.BACK_SPACE],
      this,
      () => {
        this.removeLastPoint();
      }
    ));
    
    // Finish current measurement with Enter
    this.addTrigger(new swea.editor.interactions.EventHandler(
      [swea.editor.interactions.eventCodes.ENTER],
      this,
      () => {
        this._endDrawing();
      }
    ));
  }

  /**
   * When the interaction is initialized open the correct context menu.
   * @param element { DOMElement } The element that the interaction works on
   * @param viewerId { number } The viewerId
   * @override
   */
  whenInitialized(element, viewerId){
    viewerId;

    ContextMenuStateServiceActions.openContextMenu(
      globals.LOWER_CONTEXT_MENU,
      globals.MEASURE_ACTIVATED
    );

    this._disabledInteractionClasses = swea.editor.InteractionManager.instance().disableContinuousInteractions();

    InstructionServiceActions.showInstruction(BrowserInfo.isMobile() ? 'instructions.create_area_or_line_touch' : 'instructions.create_area_or_line');
  }

  /**
   * Terminates the interaction closing the context menu.
   * @override
   */
  terminate() {
    // Will also terminate this interaction
    super.terminate();
    swea.editor.InteractionManager.instance().enableContinuousInteractions(this._disabledInteractionClasses);
    // NOTE: Would close the context menu for the first measurement created. Menu is closed from CustomSelectInteraction.whenSelected anyway.
    /*ContextMenuStateServiceActions.closeContextMenu(
      globals.LOWER_CONTEXT_MENU
    );*/
    InstructionServiceActions.hideInstruction();
  }
}
export default CustomMeasureInteraction;
